const ICONS = {
  ChannelPayLogo: require("./channelpaylogo.svg").default,
  adminLogo: require("./adminLogo.svg").default,
  homeLogo: require("./homeLogo.svg").default,
};

export default ICONS;
